import styled from 'styled-components'
import {Button, Modal} from '@components/lib'

export const TokenTransferModal = styled(Modal)`
  z-index: 1302;
`

export const Description = styled.p`
  color: ${({theme}) => theme.colors.textPrimary};
  font-weight: 400;
  font-size: ${({theme}) => theme.fontSizes.small};
`
export const ButtonContainer = styled.div`
  display: flex;
`

export const ButtonBottom = styled(Button)`
  margin-top: 15px;
  margin-right: 30px;
`

export const SuccessMessage = styled.p`
  color: ${({theme}) => theme.colors.success};
  font-weight: 400;
  font-size: ${({theme}) => theme.fontSizes.small};
`
export const ErrorMessage = styled.p`
  color: ${({theme}) => theme.colors.red};
  font-weight: 400;
  font-size: ${({theme}) => theme.fontSizes.small};
`
